<template>
  <generic-modal :title="$t('property type details')" ref="generic_modal">
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("name") }}</label>
          <div class="control">
            <p class="content has-text-weight-bold">{{ meta.name }}</p>
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t("description") }}</label>
          <div class="control">
            <div class="content">
              <p>{{ meta.description || $t("no description") }}</p>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t("status") }}</label>
          <div class="control">
            <span
              class="tag"
              :class="{
                'is-success': meta.status === 'active',
                'is-danger': meta.status === 'inactive',
              }"
            >
              {{ $t(meta.status) }}
            </span>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <label class="label">{{ $t("created") }}</label>
          <div class="control">
            <p class="content">
              {{ format_date(meta.created_at) }}<br />
              <small>{{ $t("by") }}: {{ meta.created_by }}</small>
            </p>
          </div>
        </div>

        <div class="field" v-if="meta.updated_at">
          <label class="label">{{ $t("updated") }}</label>
          <div class="control">
            <p class="content">
              {{ format_date(meta.updated_at) }}<br />
              <small>{{ $t("by") }}: {{ meta.updated_by }}</small>
            </p>
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t("usage statistics") }}</label>
          <div class="control">
            <div class="content">
              <div class="notification is-light">
                <div class="level">
                  <div class="level-item has-text-centered">
                    <div>
                      <p class="heading">{{ $t("total appraisals") }}</p>
                      <p class="title is-4">{{ meta.appraisal_count || 0 }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error handling -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>

    <!-- Footer with v-slot:footer pattern -->
    <template v-slot:footer>
      <button class="button is-primary" @click="edit_property_type">
        <span class="icon"><i class="fa fa-edit"></i></span>
        <span>{{ $t("edit") }}</span>
      </button>
      <button class="button" @click="close_modal">
        <span class="icon"><i class="fa fa-close"></i></span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import { get, generate_error_message_text, format_date } from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "PropertyTypeDetailModal",
  components: {
    GenericModal,
  },
  data() {
    return {
      meta: {
        name: "",
        description: "",
        status: "",
        appraisal_count: 0,
        created_at: "",
        created_by: "",
        updated_at: "",
        updated_by: "",
        uuid: null,
      },
      error: "",
    };
  },
  methods: {
    show_modal(uuid) {
      let v = this;
      v.entity_uuid = uuid;
      v.set_initial_state();
      v.get_property_type(uuid);
      v.$refs.generic_modal.show_modal();
    },

    close_modal() {
      this.$refs.generic_modal.close_modal();
      this.set_initial_state();
    },

    get_property_type(uuid) {
      let v = this;
      get("/appraisal/property_type", { uuid })
        .then((property_type) => {
          v.meta = { ...v.meta, ...property_type };

          // Get usage statistics
          v.get_usage_statistics(uuid);
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },

    get_usage_statistics(property_type_id) {
      let v = this;
      get("/appraisal/appraisal/datatables", {
        draw: 1,
        start: 0,
        length: 0,
        search: { value: "", regex: false },
        columns: [{ data: "property_type_id", searchable: true }],
        "columns[0][search][value]": property_type_id,
        count_only: true,
      })
        .then((response) => {
          if (response && typeof response.recordsTotal !== "undefined") {
            v.meta.appraisal_count = response.recordsTotal;
          }
        })
        .catch(() => {
          // Ignore errors for statistics
          v.meta.appraisal_count = 0;
        });
    },

    edit_property_type() {
      this.$emit("edit", this.meta.uuid);
      this.close_modal();
    },

    set_initial_state() {
      this.meta = {
        name: "",
        description: "",
        status: "",
        appraisal_count: 0,
        created_at: "",
        created_by: "",
        updated_at: "",
        updated_by: "",
        uuid: null,
      };
      this.error = "";
    },

    format_date,
  },
};
</script>

<style scoped>
.content {
  margin-bottom: 0.5rem;
}

.tag {
  font-weight: bold;
}

.notification.is-light {
  background-color: #f5f5f5;
}

.level-item {
  padding: 0.5rem;
}
</style>
